import { StackScreenProps } from "@react-navigation/stack";
import { ManageDocketTemplateFilterRootParamList } from "../../../../types";
import { DocketFilterFormValues } from "../../components/DocketTemplateForm/types";
import { UseFormReturn } from "react-hook-form";
import { FlatActionList, Page } from "@towersystems/roam-common-native";
import { DocketFilterType } from "@towersystems/roam-common/lib/generated-types";
import { InnerFormContext } from "../ManageDocketTemplateFilterRootScreen";
import React from "react";

export interface DocketTemplateFilterSelectTypeScreenProps
  extends StackScreenProps<
    ManageDocketTemplateFilterRootParamList,
    "DocketTemplateFilterSelectTypeScreen"
  > {}

export const DocketTemplateFilterSelectTypeScreen = ({
  navigation,
}: DocketTemplateFilterSelectTypeScreenProps) => {
  const filterFormContext = React.useContext(
    InnerFormContext
  ) as UseFormReturn<DocketFilterFormValues>;

  const { setValue, watch } = filterFormContext;
  const watchedType = watch("type");
  return (
    <Page title="Select filter type">
      <FlatActionList
        items={[
          {
            title: DocketFilterType.TAG,
            selected: watchedType === DocketFilterType.TAG,
            onPress: () => {
              setValue("type", DocketFilterType.TAG, {
                shouldDirty: true,
              });
              navigation.goBack();
            },
            key: DocketFilterType.TAG,
          },
          {
            title: DocketFilterType.DEPARTMENT,
            selected: watchedType === DocketFilterType.DEPARTMENT,
            onPress: () => {
              setValue("type", DocketFilterType.DEPARTMENT, {
                shouldDirty: true,
              });
              navigation.goBack();
            },
            key: DocketFilterType.DEPARTMENT,
          },
          {
            title: DocketFilterType.CATEGORY,
            selected: watchedType === DocketFilterType.CATEGORY,
            onPress: () => {
              setValue("type", DocketFilterType.CATEGORY, {
                shouldDirty: true,
              });
              navigation.goBack();
            },
            key: DocketFilterType.CATEGORY,
          },
        ]}
      />
    </Page>
  );
};
